import { useAppSelector } from "@/services/store";
import * as React from "react";
import { useErrorBoundary } from "react-error-boundary";
import { Permission, PermissionMapping } from "./permissions.utils";

interface HasPermissionProps {
  permission: Permission | Permission[];
  raise403?: boolean;
  allowIf?: boolean;
}
export const HasPermission: React.FC<React.PropsWithChildren<HasPermissionProps>> = ({
  children,
  raise403,
  permission,
  allowIf = false,
}) => {
  const { showBoundary } = useErrorBoundary();
  const groups = useAppSelector(state => state.auth.groups) ?? [];

  if (allowIf) {
    return <>{children}</>;
  }

  let permissions: Permission[];
  if (!Array.isArray(permission)) {
    permissions = [permission];
  } else {
    permissions = permission;
  }

  if (groups.includes(PermissionMapping.super_admin)) {
    return <>{children}</>;
  }

  if (!groups!.some(group => permissions.some(p => group === PermissionMapping[p]))) {
    if (raise403) {
      showBoundary({ errors: [{ status: 403 }] });
    }
    return <></>;
  }

  return <>{children}</>;
};
export const HasNoPermission: React.FC<React.PropsWithChildren<HasPermissionProps>> = ({
  children,
  raise403,
  permission,
  allowIf = false,
}) => {
  // Similar to HasPermission, but checks if the user does not have the specified permission
  const { showBoundary } = useErrorBoundary();
  const groups = useAppSelector(state => state.auth.groups) ?? [];

  if (allowIf) {
    return <>{children}</>;
  }

  let permissions: Permission[];
  if (!Array.isArray(permission)) {
    permissions = [permission];
  } else {
    permissions = permission;
  }

  if (groups!.some(group => permissions.some(p => group === PermissionMapping[p]))) {
    if (raise403) {
      showBoundary({ errors: [{ status: 403 }] });
    }
    return <></>;
  }

  return <>{children}</>;
};
